import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmarkRemove: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bookmark-remove, off"><path d="M19.25 12.75V21.25L12 17.25L4.75 21.25V18.25M4.75 13.5V2.75H19.25V8.36432" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M1.75 15.25L22.25 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBookmarkRemove;
